import requestAPI from '@/logic/requestBeApi';

const canDelAccount = () => {
  return localStorage.getItem('isAccountDeletable') === 'true';
};

const showWarningAboutLackOfAbilityToDelAccount = (self: any) => {
  self.$message.warning({
    message: self.$t('cannotDelWhenProj'),
    duration: 10000,
  });
};

const helpToDeleteAccount = (self: Record<string, any>, userRole: string): void => {
  const canDeleteAccount = canDelAccount();
  if (!canDeleteAccount) {
    showWarningAboutLackOfAbilityToDelAccount(self);
    return;
  }

  self
    .$confirm(self.$t('sureToDeleteAccountText'), self.$t('sureToDeleteTitle'), {
      confirmButtonText: self.$t('delete'),
      confirmButtonClass: 'el-button--danger',
      cancelButtonText: self.$t('cancel'),
      type: 'error',
    })
    .then(async () => {
      self.deletingAccount = true;

      const resp = await requestAPI({ url: `/api/v1/${userRole}s/me`, method: 'DELETE' });

      if (resp.status === 204) {
        self.$message.info(self.$t('accountDeleted'));

        setTimeout(() => {
          self.logOut();
        }, 3000);

        return;
      } else if (resp.status !== 401) self.$message.error(self.$t('someErrorOccurred'));

      self.deletingAccount = false;
    })
    .catch((err: Error) => err);
};

export default helpToDeleteAccount;
